<ng-template [ngIf]="config">
    <div [ngClass]="class">
      <app-content-control *ngIf="controls" [contentControls]="controls"></app-content-control>
      </div>
</ng-template>
